import React, { Component } from "react";

const Footer = props => {
  return (
    <footer>
      <div className="container text-center footerSection">
        Copyright © {new Date().getFullYear()} Parishrama Sports Academy
      </div>
    </footer>
  );
};

export default Footer;